import React, { useEffect, useState } from 'react';

import { useField } from '@unform/core';

import { IFile, useFiles } from '~/hooks/files';

import FileList from './FileList';
import FileUpload from './FileUpload';
import { CategorySubTitle, Container, Content, ErrorSpan } from './styles';

interface FileProps {
  formFieldId?: string;
  label?: string;
  acceptedTypes?: string[];
  message?: string;
  multiple?: boolean;
}

const File: React.FC<FileProps> = ({
  formFieldId = 'fileInput',
  label = 'Arquivos',
  acceptedTypes,
  message,
  multiple = true,
}) => {
  const [files, setFiles] = useState<IFile[]>([]);
  const [historyFiles, setHistoryFiles] = useState<IFile[]>([]);

  const {
    uploadedFiles,
    historyFiles: hookHistoryFiles,
    loadingHistoryFiles,
  } = useFiles();

  const { fieldName, registerField, error } = useField(formFieldId);

  useEffect(() => {
    registerField({
      name: fieldName,
      path: 'value',
    });
  }, [fieldName, registerField]);

  useEffect(() => {
    let newFiles = hookHistoryFiles;
    if (formFieldId) {
      newFiles = hookHistoryFiles.filter(
        (historyFile) => historyFile.formFieldId === formFieldId,
      );
    }

    setHistoryFiles(newFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hookHistoryFiles]);

  useEffect(() => {
    let newFiles = uploadedFiles;
    if (formFieldId) {
      newFiles = uploadedFiles.filter(
        (uploadedFile) => uploadedFile.formFieldId === formFieldId,
      );
    }

    setFiles(newFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedFiles]);

  return (
    <Container>
      <Content>
        <span>{label}</span>
        {(multiple || (!multiple && files.length < 1)) && (
          <FileUpload
            customFileTypes={acceptedTypes}
            customMessage={message}
            formFieldId={formFieldId}
            multiple={multiple}
          />
        )}
        <FileList files={files} />
        {!loadingHistoryFiles && historyFiles.length > 0 && (
          <>
            <CategorySubTitle>Histórico</CategorySubTitle>
            <FileList files={historyFiles} canDelete={false} />
          </>
        )}
        {error && <ErrorSpan>{error}</ErrorSpan>}
      </Content>
    </Container>
  );
};

export default File;
